import * as React from 'react';
import { translate } from 'react-i18next';
import { IItemCardProps } from 'models/itemcard';
import * as c from 'models/constants';
import { IUserShippingAddress } from 'models/user/shipping/usershippingaddress';
import { PortalPageSection } from 'components/PortalStructure';
import renderIcon from 'helpers/renderIcon';
import { BasicButton, BasicButtonGrey } from 'components/Common/Button';

require('./style.css');

interface IProps extends IItemCardProps {
	item: IUserShippingAddress;
	setDefaultUserShippingAddress?: (addressId: string) => void;
	isSingleAddress?: boolean;
	t?: (key: string, options?: any) => string;
}
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class UserShippingAddressItemCard extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.editItem = this.editItem.bind(this);
		this.deleteItem = this.deleteItem.bind(this);
		this.handleSetDefaultUserShippingAddressClick = this.handleSetDefaultUserShippingAddressClick.bind(this);
	}

	public editItem() {
		if (this.props.editItem) {
			this.props.editItem(this.props.item.id);
		}
	}

	public deleteItem(e: any) {
		e.stopPropagation();
		if (this.props.deleteItem) {
			this.props.deleteItem(null, this.props.item.id);
		}
	}

	private handleSetDefaultUserShippingAddressClick(e: React.SyntheticEvent, addressId: string) {
		e.preventDefault();
		this.props.setDefaultUserShippingAddress(addressId);
	}

	public render() {
		const { item, t, isSingleAddress } = this.props;

		const country = t(`DV_Countries_${item.countryKey}`);

		let fullPhoneNumber = '';
		if (item.callingCodeKey) {
			fullPhoneNumber = t(`DV_CountryCallingCodes_${item.callingCodeKey}`);
		}

		if (item.phoneNumber) {
			fullPhoneNumber = fullPhoneNumber + item.phoneNumber;
		}

		return (
			<div key={item.id} className="userShippingAddressItemCard">
				<PortalPageSection
					title={t('User_Shipping_ShippingAddresses_Label_Address')}
					readOnly={true}
					toggleEdit={this.editItem}
				>
					<dl className="list">
						<dt>{t('User_Shipping_ManageShippingAddress_Label_Name')}</dt>
						<dd>{item.name}</dd>
						<dt>{t('User_Shipping_ShippingAddresses_Label_Street')}</dt>
						<dd>{item.addressLine1}</dd>
						{item.addressLine2 ? (
							<>
								<dt>{t('User_Shipping_ShippingAddresses_Label_Street2')}</dt>
								<dd>{item.addressLine2}</dd>
							</>
						) : null}
						<dt>{t('User_Shipping_ShippingAddresses_Label_PostCodeCity')}</dt>
						<dd>
							{item.zipCode} {item.city}
						</dd>
						{item.state ? (
							<>
								<dt>{t('User_Shipping_ShippingAddresses_Label_StateProvince')}</dt>
								<dd>{item.state}</dd>
							</>
						) : null}
						<dt>{t('User_Shipping_ShippingAddresses_Label_Country')}</dt>
						<dd>{country}</dd>
						<dt>{t('User_Shipping_ShippingAddresses_Label_DeliveryNotes')}</dt>
						<dd className={item.note ? '' : 'light'}>{item.note ? item.note : '/'}</dd>
						<dt>{t('User_Shipping_ShippingAddresses_Label_Phone')}</dt>
						<dd>{fullPhoneNumber}</dd>
						<dt className="dark">
							{item.isDefault || isSingleAddress ? (
								<>
									{renderIcon('check1')} {t('User_Shipping_ShippingAddresses_Label_DefaultAddress')}
								</>
							) : (
								<BasicButtonGrey
									onClick={(e) => {
										this.handleSetDefaultUserShippingAddressClick(e, item.id);
									}}
								>
									{t('User_Shipping_ShippingAddresses_Button_SetDefaultAddress')}
								</BasicButtonGrey>
							)}
						</dt>
					</dl>
					<hr />
					<dl>
						<dt>
							<BasicButton onClick={this.deleteItem}>
								{renderIcon('delete_2')}
								{t('User_Shipping_ShippingAddresses_Remove')}
							</BasicButton>
						</dt>
					</dl>
				</PortalPageSection>
			</div>
		);
	}
}

export { UserShippingAddressItemCard };
